<script>
import UploadZone from '@/components/UploadZone.vue'
import { extractBillFromPdf } from '@/utils/billExtractor'
import { mapearJsonParaForm } from '@/utils/mapearJsonParaForm'

export default {
  components: { UploadZone },

  props: {
    form:    { type: Object, required: true },
    pdfFile: { type: File,   default: null },
  },

  data() {
    return {
      extraindo: false,
      erro: '',
    }
  },

  methods: {
    onUpload(file) {
      this.erro = ''
      this.$emit('pdf-changed', file)
    },
    onRemover() {
      this.$emit('pdf-changed', null)
    },
    async extrairEAvancar() {
      const file = this.pdfFile
      if (!file) {
        this.$toast.error('Selecione o PDF da conta antes de continuar.')
        return
      }
      const isPdf = file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf')
      if (!isPdf) {
        this.$emit('modo-manual')
        return
      }

      this.extraindo = true
      this.erro = ''
      try {
        const { data } = await extractBillFromPdf(file)
        const meta = mapearJsonParaForm(data, this.form)
        this.$emit('extracao-finalizada', { extracted: data, meta })
      } catch (err) {
        const msg = err?.response?.data?.error?.message
          || err?.message
          || 'Não foi possível processar o PDF. Tente outro arquivo.'
        this.erro = msg
      } finally {
        this.extraindo = false
      }
    },
  },
}
</script>

<template>
  <div>
    <UploadZone
      label="Envie o arquivo da sua conta de energia"
      :value="pdfFile ? pdfFile.name : ''"
      hint="Envie o arquivo PDF digital da sua conta. Se não tiver o PDF, pode enviar uma foto ou imagem."
      :max-mb="50"
      @change="onUpload"
      @remover="onRemover"
    />

    <div v-if="erro" class="alert alert--danger" style="margin-top: 16px">
      <p style="margin: 0 0 12px">{{ erro }}</p>
      <!-- Saída para não travar o cadastro: o arquivo continua anexado e é enviado no final -->
      <button type="button" class="btn btn--ghost" @click="$emit('modo-manual')">
        Continuar e preencher os dados manualmente
      </button>
    </div>

    <div class="actions-row">
      <span />
      <button type="button" class="btn btn--primary" :disabled="extraindo || !pdfFile" @click="extrairEAvancar">
        <span v-if="extraindo" class="spinner" aria-hidden="true" />
        {{ extraindo ? 'Lendo seu PDF...' : 'Continuar' }}
      </button>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "~@/design/tokens";

.spinner {
  width: 16px; height: 16px;
  border-radius: 50%;
  border: 2px solid rgba(255,255,255,.4);
  border-top-color: $text-on-brand;
  animation: spin .7s linear infinite;
  display: inline-block;
  margin-right: $space-2;
}
@keyframes spin { to { transform: rotate(360deg); } }
</style>
